<template>
  <div class="commodity-rank">
    <div
      v-if="tableList.length"
      class="self-table"
    >
      <table
        border="0"
        style="border-collapse: collapse;"
      >
        <thead>
          <tr>
            <th
              scope="col"
              v-for="(item, index) in tableTitle"
              :key="index"
            >
              {{item}}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item,index) in tableList"
            :key="index"
            scope="row"
          >
            <th>{{ index + 1 }}</th>
            <th>{{ item.saleCityName }}</th>
            <td>{{ item.totalAmount }}</td>
            <td>{{ item.grossAmount }}</td>
            <td>{{ item.orderQuantity }}</td>
            <td>{{ item.bulkGoodsOrderQuantity }}</td>
            <td>{{ item.cutOrderQuantity }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <DataEmpty
      v-else
      style="height: 200px;"
    />
  </div>
</template>

<script>
import { commodityCitySellingRank } from '@/api/crm';
import setHeaderMixins from '@/mixins/set-header';
import DataEmpty from '@/components/data-empty';

export default {
  name: 'CityRank',
  mixins: [setHeaderMixins],
  components: { DataEmpty },

  data() {
    return {
      tableTitle: ['排名', '城市', 'GMV', '毛利', '订单数', '大货数', '剪版数'],
      tableList: [
        // {
        //   saleCityName: '无敌是最寂寞最是痛苦',
        //   totalAmount: 1,
        //   grossAmount: 1,
        //   orderQuantity: 1,
        //   bulkGoodsOrderQuantity: 1,
        //   cutOrderQuantity: 1,
        // },
      ],
      query: {
        timeType: '',
        startDate: '',
        endDate: '',
        searchUserId: '',
        searchDepartmentId: '',
        purchaserCode: '',
        searchType: '',
        commodityNo: '', // 商品编码
      },

    };
  },
  watch: {
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      const { query } = this.$route;
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '加载中...',
      });
      try {
        query.searchInfo = query.searchInfo ? JSON.parse(query.searchInfo) : '';
        const { data } = await commodityCitySellingRank(query);
        this.tableList = data?.rankInfos;
      } catch (e) {
        console.log(e);
      } finally {
        this.$toast.clear();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .self-table {
    th, td {
      min-width: 80px;
      max-width: 130px;
      text-align: center;
      height: 44px;
      empty-cells: show;
      overflow: hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      /*padding:0 6px;*/
      background: white;
      color: #999999;
      font-weight: 500;
      font-size: 14px;
      text-align:center;
      vertical-align:middle;
    }
    thead {
      th, td {
        background:rgba(245,245,249,1);
      }
      th {
        top:0;
        index: 2;
      }
      tr th:first-of-type {
        min-width: 35px;
        left:0; z-index:1;
      }
      tr th:nth-of-type(2){
        left:35px; z-index:1;
      }
    }
    table {
      table-layout:fixed;
    }
    th {
      position:-webkit-sticky;
      position:sticky;
    }

    tbody {
      th:first-of-type {
        min-width: 35px;
        left:0;
      }
      tr th:nth-of-type(2){
        left:35px;
      }
      td {
        padding: 0 5px;
      }
    }
  }

</style>
